import React from 'react';

import {AbstractMapItem, MapInput} from '../MapItems/MapItems';

import './WDRWindItem.css';

export function WDRWindItem(props) {
  const item = props.item;
  const velocity = Object.keys(item.data)[0];
  const direction = Object.keys(item.data)[1];

  function calcRotation(index) {
    return parseInt(270 + (index - 1) * 22.5);
  }

  function createWindArrow(iconIndex) {
    if (iconIndex === 0) {
      return;
    }
    // const angle = 90 + (item.data.direction.value - 1) * 22.5
    if (iconIndex >= 1 && iconIndex <= 16) {
      return (
        <div
          className='wdr-wind-arrow-icon'
          style={{
            backgroundImage: item.ui.arrowStraight,
            backgroundPosition: 'center',
            transform: 'rotate(' + calcRotation(iconIndex) + 'deg)'
          }}></div>
      );
    } else if (iconIndex === 17) {
      return (
        <div
          className='wdr-wind-arrow-icon'
          style={{
            backgroundImage: item.ui.arrowRotating,
            transform: 'rotate(90deg) scaleY(-1)'
          }}></div>
      );
    } else if (iconIndex === 18) {
      return (
        <div
          className='wdr-wind-arrow-icon'
          style={{
            backgroundImage: item.ui.arrowRotating,
            transform: 'rotate(135deg) '
          }}></div>
      );
    } else {
      return;
    }
  }
  return (
    <AbstractMapItem {...props}>
      <div className='wdr-wind'>
        <div className='wdr-wind-vel-input-wrapper'>
          <MapInput
            item={item}
            data={{key: direction, value: item.data[direction].value}}
            callback={props.setValueInMap}
          />
        </div>
        <br></br>

        <div
          className='wdr-wind-dir-wrapper'
          style={{width: '70px', height: '70px'}}>
          <MapInput
            item={item}
            data={{key: velocity, value: item.data[velocity].value}}
            callback={props.setValueInMap}
          />
          {createWindArrow(item.data.direction.value)}
        </div>

        <br></br>
      </div>
    </AbstractMapItem>
  );
}
